export default {
  path: '/main/externalStatistics/channelCustomer',
  name: 'ChannelCustomer',
  component: () =>
    import(
      '@/views/main/externalStatistics/channelCustomer/ChannelCustomer.vue'
    ),
  children: []
}
